import { platformRequest } from 'react-common'

type Unit = {
  id: string
  parent_id: string | undefined
  tenant_id: string
  application_id: string
  name: string
  code: string
  description: string
}

type UnitWithUserMembership = {
  id: string
  title: string
  is_primary: boolean
  started: string
  finished: string
  external_id: string
}

export type UnitAssignedToUser = {
  unit: Unit
  membership: UnitWithUserMembership[]
}

type ListResponse<T = null> = {
  items: T[]
}

export class ProfileApi {
  private static readonly unitsEndpoint = platformRequest('users/:id/units')
  private static readonly timezone = platformRequest('users/:id/timezone')

  static units(userId: string) {
    return this.unitsEndpoint.get({ url: { id: userId } }).then((res) => res.body as ListResponse<UnitAssignedToUser>)
  }

  static setUserTimezone({ id, timezone }: { id: string; timezone: string }) {
    return this.timezone.post({ body: { timezone }, url: { id } })
  }
}
